import React, { useEffect, useState } from "react";
import { ButtonComponent, DatePickerComponent, InputField, PriceInputBox, SelectBox } from "../component/Common";
import { insuranceType, yesNoArray } from "../constants/form_constatnts";
import api from "../utils/api";
import Swal from "sweetalert2";
import { useLocation, useNavigate } from "react-router-dom";

const ExpensesDetails = ({ onNextPage, onPriviousPage }) => {
    const navigate = useNavigate();
    const [expensesDetails, setexpensesDetails] = useState({
        electricityBill: null,
        gasBill: null,
        waterBill: null,
        mobileBill: null,
        telephoneBill: null,
        broadBandBill: null,
        skyTvBill: null,
        councilTaxBill: null,
        TvLicenceBill: null,
        foodBill: null,
        travelCostsBill: null,
        otherFixedExpenses: null,
        insurenceStatus: null,
        insurenceDetails: []
    })

    const [isInitialLoad, setIsInitialLoad] = useState(true);
    const [errors, setErrors] = useState({});

    useEffect(() => {
        setIsInitialLoad(false);
    }, []);

    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const applicationId = searchParams.get('applicationId');

    useEffect(() => {
        if (!isInitialLoad) {
            if (applicationId) {
                fetchExpensesData(applicationId)
            }
        }
    }, [isInitialLoad]);

    const fetchExpensesData = async (id) => {
        try {
            const result = await api.get(`/get-expenses-details/${id}`);
            const data = result.data;
            if (data) {
                const updateExpense = {
                    electricityBill: data.expensesDetails.electricityBill,
                    gasBill: data.expensesDetails.gasBill,
                    waterBill: data.expensesDetails.waterBill,
                    mobileBill: data.expensesDetails.mobileBill,
                    telephoneBill: data.expensesDetails.telephoneBill,
                    broadBandBill: data.expensesDetails.broadBandBill,
                    skyTvBill: data.expensesDetails.skyTvBill,
                    councilTaxBill: data.expensesDetails.councilTaxBill,
                    TvLicenceBill: data.expensesDetails.TvLicenceBill,
                    foodBill: data.expensesDetails.foodBill,
                    travelCostsBill: data.expensesDetails.travelCostsBill,
                    otherFixedExpenses: data.expensesDetails.otherFixedExpenses,
                    insurenceStatus: yesNoArray.find(option => option.value === data.expensesDetails.insuranceStatus) || '',
                }
                // Update state
                setexpensesDetails(prevData => ({
                    ...prevData,
                    ...updateExpense,
                }));

                if (data.expensesDetails.insurance.length > 0) {
                    setexpensesDetails(prevData => ({
                        ...prevData,
                        insurenceDetails: data.expensesDetails.insurance.map(row => ({
                            id: row.id,
                            insuranceType: insuranceType.find(option => option.value === row.insuranceType) || '',
                            cost: row.cost,
                            renewalDate: row.renewalDate,
                            providerName: row.providerName,
                        })),
                    }));
                }
            }
        } catch (error) {
            console.log("Error fetching expenses details:", error);
        }
    }

    const handleInputChange = (e) => {
        const { id, value } = e.target;
        setexpensesDetails((prevData) => ({ ...prevData, [id]: value }));
        setErrors((prevData) => {
            const newErrors = { ...prevData };
            delete newErrors[id];
            return newErrors;
        });
    };

    const handleSelectChange = (value, name) => {
        setexpensesDetails((prevData) => ({ ...prevData, [name]: value }));
        setErrors((prevData) => ({ ...prevData, [name]: "" }));
        if (value.value === "Yes") {
            setexpensesDetails((prevData) => ({
                ...prevData,
                insurenceDetails: [
                    ...prevData.insurenceDetails,
                    {
                        insuranceType: '',
                        cost: '',
                        renewalDate: '',
                        providerName: '',
                    }
                ]
            }));
        } else {
            setexpensesDetails((prevData) => ({ ...prevData, insurenceDetails: [] }));
        }
    };

    const handleIsuranceData = (index, name, value) => {
        const newInsurance = [...expensesDetails.insurenceDetails];
        newInsurance[index] = {
            ...newInsurance[index],
            [name]: value
        };
        setexpensesDetails((prevData) => ({ ...prevData, insurenceDetails: newInsurance }));
        setErrors((prevData) => ({ ...prevData, [`${name}${index}`]: "" }));
    };

    const handleInsuranceInputData = (index, name, e) => {
        const { value } = e.target;
        const newInsurance = [...expensesDetails.insurenceDetails];
        newInsurance[index] = {
            ...newInsurance[index],
            [name]: value
        };
        setexpensesDetails((prevData) => ({ ...prevData, insurenceDetails: newInsurance }));
        setErrors((prevData) => {
            const newErrors = { ...prevData };
            delete newErrors[`${name}${index}`];
            return newErrors;
        });
    }


    //handle error message
    useEffect(() => {
        for (const key in errors) {
            const errorMessageElement = document.getElementById(`error-message-${key}`);
            const dateErrorMessageElement = document.getElementById(`date-error-message-${key}`);
            const input = document.getElementById(`${key}`);
            if (errorMessageElement) {
                errorMessageElement.textContent = errors[key];
                if (input && input.tagName.toLowerCase() === 'input') {
                    if (errorMessageElement.textContent === '') {
                        input.style.setProperty('border', 'none', 'important');
                        input.style.setProperty('border-radius', '0', 'important');
                    } else {
                        input.style.setProperty('border', '1px solid red', 'important');
                        input.style.setProperty('border-radius', '5px', 'important');
                    }
                }
            }
            if (dateErrorMessageElement) {
                dateErrorMessageElement.textContent = errors[key];
                if (input) {
                    const wrapper = input.getElementsByClassName('react-date-picker__wrapper')[0];
                    if (wrapper) {
                        if (dateErrorMessageElement.textContent === '') {
                            wrapper.style.setProperty('border', '1px solid gray', 'important');
                        } else {
                            wrapper.style.setProperty('border', '1px solid red', 'important');
                        }
                    }
                }
            }
        }
    }, [errors]);

    var isValid = true;
    const newErrors = {};
    let firstErrorFieldId = null;
    const setFieldError = (field, fieldName, errorMsg) => {
        if (!field) {
            isValid = false;
            newErrors[fieldName] = errorMsg;
            if (!firstErrorFieldId) firstErrorFieldId = fieldName; // Set the first error field
        }
    };

    const handleGoBack = () => {
        onPriviousPage()
    };

    const handleFormSubmission = async () => {

        setFieldError(expensesDetails.electricityBill, "electricityBill", "Electricity Bill is required.");
        setFieldError(expensesDetails.gasBill, "gasBill", "Gas Bill is required.");
        setFieldError(expensesDetails.waterBill, "waterBill", "Water Bill is required.");
        setFieldError(expensesDetails.mobileBill, "mobileBill", "Mobile Bill is required.");
        setFieldError(expensesDetails.telephoneBill, "telephoneBill", "Telephone Bill is required.");
        setFieldError(expensesDetails.broadBandBill, "broadBandBill", "Broadband Bill is required.");
        setFieldError(expensesDetails.skyTvBill, "skyTvBill", "Sky TV Bill is required.");
        setFieldError(expensesDetails.councilTaxBill, "councilTaxBill", "Council Tax Bill is required.");
        setFieldError(expensesDetails.TvLicenceBill, "TvLicenceBill", "TV Licence Bill is required.");
        setFieldError(expensesDetails.foodBill, "foodBill", "Food Bill is required.");
        setFieldError(expensesDetails.travelCostsBill, "travelCostsBill", "Travel Costs Bill is required.");
        setFieldError(expensesDetails.otherFixedExpenses, "otherFixedExpenses", "Other Fixed Expenses are required.");
        setFieldError(expensesDetails.insurenceStatus, "insurenceStatus", "Insurance Status is required.");
        if (expensesDetails.insurenceStatus && expensesDetails.insurenceStatus.value === 'Yes') {
            validateInsurance()
        }

        setErrors(newErrors);
        const errorObjects = document.getElementsByClassName('error_message');
        for (const element of Array.from(errorObjects)) {
            if (element.innerText !== "") {
                isValid = false;
                const result = element.id.split('-');
                firstErrorFieldId = result[result.length - 1];
                break;
            }
        };;

        if (isValid) {
            try {
                const result = await api.post(`/expenses-details/${applicationId}`, expensesDetails);
                if (result.status == 200) {
                    Swal.fire({
                        icon: "success",
                        title: result.data.message,
                        iconColor: '#008000',
                        showConfirmButton: false,
                        timer: 2000
                    });
                    onNextPage();
                }
            } catch (error) {
                console.log("post api error in expenses form:", error);
            }
        } else {
            if (firstErrorFieldId) {
                const element = document.getElementById(firstErrorFieldId);
                if (element) {
                    element.scrollIntoView({ behavior: "smooth", block: "start" });
                    const yOffset = -120;
                    const yPosition = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
                    window.scrollTo({ top: yPosition, behavior: "smooth" });
                    element.focus();
                }
            }
            return;
        }
    }

    const saveFormData = async () => {
        var isValid = true;
        let firstErrorFieldId = null;
        const errorObjects = document.getElementsByClassName('error_message');
        for (const element of Array.from(errorObjects)) {
            if (element.innerText !== "") {
                isValid = false;
                const result = element.id.split('-');
                firstErrorFieldId = result[result.length - 1];
                break;
            }
        };

        if (isValid) {
            try {
                const result = await api.post(`/expenses-details/${applicationId}`, expensesDetails);
                if (result.status === 200) {
                    Swal.fire({
                        icon: "success",
                        title: "Your details have been saved successfully",
                        iconColor: '#008000',
                        showConfirmButton: true,
                        showCancelButton: true,
                        confirmButtonText: 'Exit ',
                        confirmButtonColor: '#0E2F4F',
                        cancelButtonText: 'Stay on Page',
                    }).then(async (response) => {
                        if (response.isConfirmed) {
                            navigate('/mortgage_dashboard');
                            // try {
                            //     const logoutResult = await api.get('/logout');
                            //     if (logoutResult.status === 200) {
                            //         localStorage.removeItem('token');
                            //         window.location.href = 'https://mortgageapp.gargneha.com';
                            //     }
                            // } catch (logoutError) {
                            //     console.error("Logout API error:", logoutError);
                            // }
                        }
                    });
                }
            } catch (error) {
                console.log("Post API error:", error);
            }
        } else {
            if (firstErrorFieldId) {
                const element = document.getElementById(firstErrorFieldId);
                if (element) {
                    element.scrollIntoView({ behavior: "smooth", block: "start" });
                    const yOffset = -220;
                    const yPosition = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
                    window.scrollTo({ top: yPosition, behavior: "smooth" });
                    element.focus();
                }
            }
            return;
        }
    };

    const validateInsurance = () => {
        expensesDetails.insurenceDetails.forEach((insurance, index) => {
            setFieldError(insurance.insuranceType, `insuranceType${index}`, "Select an option.");
            setFieldError(insurance.cost, `cost${index}`, "Cost is required.");
            setFieldError(insurance.renewalDate, `renewalDate${index}`, "Renewal Date is required.");
            setFieldError(insurance.providerName, `providerName${index}`, "Provider Name is required.");
        });
    }

    const customSelectStyles = (fieldName) => ({
        control: (provided) => ({
            ...provided,
            borderColor: errors[fieldName] ? 'red' : provided.borderColor,
            '&:hover': {
                borderColor: errors[fieldName] ? 'red' : provided['&:hover'].borderColor,
            },
        }),
    });
    const addRemoveButtons = () => {
        return (
            <div className="input-field-row">
                {expensesDetails.insurenceDetails.length > 1 ? (
                    <button className="removeDivButton" onClick={() => removeInsurance()}>Remove Insurance</button>
                ) : (<div className="removeDivButton"></div>)}
                <button className="addDivButton" onClick={() => addInsurance()}>Add another Insurance</button>
            </div>
        )
    }

    const removeInsurance = () => {
        var nextInsurance = [...expensesDetails.insurenceDetails];
        if (nextInsurance.length > 1) {
            nextInsurance = nextInsurance.slice(0, nextInsurance.length - 1);
            setexpensesDetails({ ...expensesDetails, insurenceDetails: nextInsurance });
        }
    }

    const addInsurance = () => {
        validateInsurance()
        setErrors(newErrors);
        const errorObjects = document.getElementsByClassName('error_message');
        for (const element of Array.from(errorObjects)) {
            if (element.innerText !== "") {
                isValid = false;
                const result = element.id.split('-');
                firstErrorFieldId = result[result.length - 1];
                break;
            }
        };

        if (isValid) {
            setexpensesDetails((prevData) => ({
                ...prevData,
                insurenceDetails: [
                    ...prevData.insurenceDetails,
                    {
                        insuranceType: '',
                        cost: '',
                        renewalDate: '',
                        providerName: '',
                    }
                ]
            }));
        } else {
            Swal.fire({
                icon: "error",
                title: "Please fill above details first.",
                iconColor: '#AB1717',
                showConfirmButton: false,
                timer: 1500
            })
        }
    }

    return (
        <>
            <div className="personal-details-form">
                <div className="form_name">Expenses Details
                    <p>All fields are required to submit the application
                        <span className="required">*</span>
                    </p>
                </div>
                <PriceInputBox
                    label="Electricity Bill:"
                    htmlFor="electricityBill"
                    value={expensesDetails.electricityBill}
                    placeholder="Enter electricity bill"
                    onChange={handleInputChange}
                />
                <PriceInputBox
                    label="Gas Bill:"
                    htmlFor="gasBill"
                    value={expensesDetails.gasBill}
                    placeholder="Enter gas bill"
                    onChange={handleInputChange}
                />
                <PriceInputBox
                    label="Water Bill:"
                    htmlFor="waterBill"
                    value={expensesDetails.waterBill}
                    placeholder="Enter water bill"
                    onChange={handleInputChange}
                />
                <PriceInputBox
                    label="Mobile Bill:"
                    htmlFor="mobileBill"
                    value={expensesDetails.mobileBill}
                    placeholder="Enter mobile bill"
                    onChange={handleInputChange}
                />
                <PriceInputBox
                    label="Telephone Bill:"
                    htmlFor="telephoneBill"
                    value={expensesDetails.telephoneBill}
                    placeholder="Enter telephone bill"
                    onChange={handleInputChange}
                />
                <PriceInputBox
                    label="Broadband Bill:"
                    htmlFor="broadBandBill"
                    value={expensesDetails.broadBandBill}
                    placeholder="Enter broadband bill"
                    onChange={handleInputChange}
                />
                <PriceInputBox
                    label="Sky TV Bill:"
                    htmlFor="skyTvBill"
                    value={expensesDetails.skyTvBill}
                    placeholder="Enter sky tv bill"
                    onChange={handleInputChange}
                />
                <PriceInputBox
                    label="Council Tax Bill:"
                    htmlFor="councilTaxBill"
                    value={expensesDetails.councilTaxBill}
                    placeholder="Enter council tax bill"
                    onChange={handleInputChange}
                />
                <PriceInputBox
                    label="TV Licence Bill:"
                    htmlFor="TvLicenceBill"
                    value={expensesDetails.TvLicenceBill}
                    placeholder="Enter tv licence bill"
                    onChange={handleInputChange}
                />
                <PriceInputBox
                    label="Food Bill:"
                    htmlFor="foodBill"
                    value={expensesDetails.foodBill}
                    placeholder="Enter food bill"
                    onChange={handleInputChange}
                />
                <PriceInputBox
                    label="Travel Costs Bill:"
                    htmlFor="travelCostsBill"
                    value={expensesDetails.travelCostsBill}
                    placeholder="Enter travel costs bill"
                    onChange={handleInputChange}
                />
                <PriceInputBox
                    label="Other: Fixed Expenses"
                    htmlFor="otherFixedExpenses"
                    value={expensesDetails.otherFixedExpenses}
                    placeholder="Enter other fixed expenses"
                    onChange={handleInputChange}
                />
                <hr />
                <p className="formHeading">Insurance Details</p>
                <SelectBox
                    label="Do you currently have any insurance coverage?"
                    htmlFor="insurenceStatus"
                    options={yesNoArray}
                    value={expensesDetails.insurenceStatus}
                    placeholder="Select an option"
                    onChange={(value) => handleSelectChange(value, 'insurenceStatus')}
                    styles={customSelectStyles('insurenceStatus')}
                />
                {expensesDetails.insurenceStatus && expensesDetails.insurenceStatus.value === 'Yes' && (
                    <>
                        {expensesDetails.insurenceDetails.map((insurance, index) => {
                            return <div key={index}>
                                {index > 0 && (<hr />)}
                                <p className="formHeading">{`${index + 1}. Insurance Details`}</p>
                                <SelectBox
                                    label="Select Insurance Type:"
                                    htmlFor={`insuranceType${index}`}
                                    options={insuranceType}
                                    value={insurance.insuranceType}
                                    placeholder="Select Insurance Type"
                                    onChange={(value) => handleIsuranceData(index, 'insuranceType', value)}
                                    styles={customSelectStyles(`insuranceType${index}`)}
                                />
                                <PriceInputBox
                                    label="Amount to be Paid:"
                                    htmlFor={`cost${index}`}
                                    value={insurance.cost}
                                    placeholder="Enter to be paid"
                                    onChange={(value) => handleInsuranceInputData(index, `cost`, value)}
                                />
                                <DatePickerComponent
                                    label="Date of Renewal:"
                                    htmlFor={`renewalDate${index}`}
                                    value={insurance.renewalDate}
                                    onChange={(date) => handleIsuranceData(index, 'renewalDate', date)}
                                />
                                <InputField
                                    label="Enter Provider's Name:"
                                    htmlFor={`providerName${index}`}
                                    placeholder="Enter your insurance provider's name"
                                    value={insurance.providerName}
                                    onChange={(value) => handleInsuranceInputData(index, `providerName`, value)}
                                />
                            </div>
                        })}
                        {addRemoveButtons()}
                    </>
                )}
                <div className="buttons-style">
                    <div className="back-btn"><ButtonComponent name="Back" onClick={handleGoBack} /></div>
                    <div className="button-div">
                        <ButtonComponent name='Save & Exit' onClick={saveFormData} />
                        <ButtonComponent label="Submit" name='Continue' onClick={handleFormSubmission} />
                    </div>
                </div>
            </div>
        </>
    )

}

export default ExpensesDetails;